import { Box, IconButton, Typography, useTheme } from '@mui/material'
import React from 'react'
import CustomTooltip from './CustomTooltip'
import { Icons } from '../../utils/utilities'

const CustomChip = ( { noWrap, containerStyles = {}, disabled = false, chipStyles = {}, textStyles = {}, tooltipPlacement = "top", textVariant, startIcon, endIcon, color, value, onClick, onEndIconClick, variant = "outlined", tooltipTitle = "", gradient = `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, count } ) => {

    const { palette, theme } = useTheme()

    const clickableEndIcon = onEndIconClick && typeof onEndIconClick === 'function'
    const clickable = onClick && typeof onClick === 'function'

    if ( !value )
        return null

    if ( variant === "outlined" )
        return (
            <Box onClick={( clickable && !disabled ) ? onClick : undefined} sx={{ cursor: "pointer", ...containerStyles }} width="fit-content" display="inline-block" position="relative">
                <CustomTooltip disableInteractive placement={tooltipPlacement} sx={{ zIndex: 400000 }} title={tooltipTitle ?? ""}>
                    <Box
                        display="flex"
                        width="fit-content"
                        gap="5px"
                        alignItems="center"
                        padding="0px 5px"
                        borderRadius="10px"
                        border={`1px solid ${color ? palette[color].main + "55" : palette.common.font + "55"}`}
                        color={color ? palette[color].main : palette.text.primary}
                        fontSize="12px"
                        sx={chipStyles}
                    >
                        {startIcon}
                        <Typography
                            className={noWrap ? 'truncate-at-1' : ''}
                            minWidth={0}
                            color={color ? palette[color].main : palette.text.primary}
                            fontSize="12px"
                            variant={textVariant || 'caption'}
                            sx={textStyles}
                        >
                            {value}
                        </Typography>
                        {count && <Typography
                            color={color ? palette[color].main : palette.text.primary}
                            fontSize="10px"
                            borderRadius="50px"
                            minWidth="20px"
                            margin="2px 0 2px 0"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            border={`1px solid ${color ? palette[color].main + "55" : palette.common.font + "55"}`}
                            variant={textVariant || 'caption'}
                        >
                            {count}
                        </Typography>}
                        {clickableEndIcon && <IconButton onClick={onEndIconClick} disabled={disabled} size='small' sx={{ fontSize: "inherit" }} >{endIcon || Icons.default.CancelIcon}</IconButton>}
                        {!clickableEndIcon && endIcon && endIcon}
                    </Box>
                </CustomTooltip>
            </Box>
        )

    if ( variant === "semifilled" )
        return (
            <Box onClick={( clickable && !disabled ) ? onClick : undefined} sx={{ cursor: "pointer", ...containerStyles }} width="fit-content" display="inline-block" position="relative">
                <CustomTooltip disableInteractive placement={tooltipPlacement} sx={{ zIndex: 400000 }} title={tooltipTitle ?? ""}>
                    <Box
                        display="flex"
                        width="fit-content"
                        gap="5px"
                        alignItems="center"
                        padding="0px 5px"
                        borderRadius="10px"
                        border={`1px solid ${color ? palette[color].main + "55" : palette.common.font + "55"}`}
                        bgcolor={color ? palette[color].light + 22 : theme === 'dark' ? palette.grey[700] : palette.grey[400]}
                        color={color ? palette[color].main : palette.text.primary}
                        fontSize="12px"
                        sx={chipStyles}
                    >
                        {startIcon}
                        <Typography
                            className={noWrap ? 'truncate-at-1' : ''}
                            minWidth={0}
                            color={color ? palette[color].main : palette.text.primary}
                            fontSize="12px"
                            variant={textVariant || 'caption'}
                            sx={textStyles}
                        >
                            {value}
                        </Typography>
                        {count && <Typography
                            color={color ? palette[color].main : palette.text.primary}
                            fontSize="10px"
                            borderRadius="50px"
                            minWidth="20px"
                            margin="2px 0 2px 0"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            border={`1px solid ${color ? palette[color].main + "55" : palette.common.font + "55"}`}
                            variant={textVariant || 'caption'}
                        >
                            {count}
                        </Typography>}
                        {clickableEndIcon && <IconButton onClick={onEndIconClick} disabled={disabled} size='small' sx={{ fontSize: "inherit" }} >{endIcon || Icons.default.CancelIcon}</IconButton>}
                        {!clickableEndIcon && endIcon && endIcon}
                    </Box>
                </CustomTooltip>
            </Box>
        )

    if ( variant === "filled" )
        return (
            <Box onClick={( clickable && !disabled ) ? onClick : undefined} sx={{ cursor: "pointer", ...containerStyles }} width="fit-content" display="inline-block" position="relative">
                <CustomTooltip disableInteractive placement={tooltipPlacement} sx={{ zIndex: 400000 }} title={tooltipTitle ?? ""}>
                    <Box
                        display="flex"
                        width="fit-content"
                        gap="5px"
                        alignItems="center"
                        padding="0px 5px"
                        borderRadius="10px"
                        border={`1px solid ${color ? palette[color].main + "55" : theme === 'dark' ? palette.grey[700] : palette.grey[400]}`}
                        bgcolor={color ? palette[color].main : theme === 'dark' ? palette.grey[700] : palette.grey[400]}
                        color={color ? palette[color].contrastText : palette.text.primary}
                        fontSize="12px"
                        sx={chipStyles}
                    >
                        {startIcon}
                        <Typography
                            className={noWrap ? 'truncate-at-1' : ''}
                            minWidth={0}
                            color={color ? palette[color].contrastText : palette.text.primary}
                            fontSize="12px"
                            variant={textVariant || 'caption'}
                            sx={textStyles}
                        >
                            {value}
                        </Typography>
                        {count && <Typography
                            color={color ? palette[color].main : palette.text.primary}
                            fontSize="10px"
                            borderRadius="50px"
                            minWidth="20px"
                            margin="2px 0 2px 0"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            border={`1px solid ${color ? palette[color].main + "55" : palette.common.font + "55"}`}
                            variant={textVariant || 'caption'}
                        >
                            {count}
                        </Typography>}
                        {clickableEndIcon && <IconButton onClick={onEndIconClick} disabled={disabled} size='small' sx={{ fontSize: "inherit" }} >{endIcon || Icons.default.CancelIcon}</IconButton>}
                        {!clickableEndIcon && endIcon && endIcon}
                    </Box>
                </CustomTooltip>
            </Box>
        )
    if ( variant === "gradient" )
        return (
            <Box onClick={( clickable && !disabled ) ? onClick : undefined} sx={{ cursor: "pointer", ...containerStyles }} width="fit-content" display="inline-block" position="relative">
                <CustomTooltip disableInteractive placement={tooltipPlacement} sx={{ zIndex: 400000 }} title={tooltipTitle ?? ""}>
                    <Box
                        display="flex"
                        width="fit-content"
                        gap="5px"
                        alignItems="center"
                        padding="0px 5px"
                        borderRadius="10px"
                        border={`1px solid ${palette[color] ? palette[color].main + "55" : theme === 'dark' ? palette.grey[700] : palette.grey[400]}`}
                        sx={{ background: gradient, ...( chipStyles || {} ) }}
                        color={palette[color] ? palette[color].contrastText : color || palette.text.primary}
                        fontSize="12px"
                    >
                        {startIcon}
                        <Typography
                            className={noWrap ? 'truncate-at-1' : ''}
                            minWidth={0}
                            color={palette[color] ? palette[color].contrastText : color || palette.text.primary}
                            fontSize="12px"
                            variant={textVariant || 'caption'}
                            sx={textStyles}
                        >
                            {value}
                        </Typography>
                        {clickableEndIcon && <IconButton onClick={onEndIconClick} disabled={disabled} size='small' sx={{ fontSize: "inherit" }} >{endIcon || Icons.default.CancelIcon}</IconButton>}
                        {!clickableEndIcon && endIcon}
                    </Box>
                </CustomTooltip>
            </Box>
        )
}

export default CustomChip
